/* eslint react-hooks/exhaustive-deps: "warn" */
import { useInt } from 'hooks/useInt';

import { TitleBlock } from 'ui/atoms/TitleBlock/TitleBlock';
import { Section } from 'ui/molecules/Section/Section';

import styles from './FddMonitoring.module.scss';

export const FddMonitoring = () => {
  const { t } = useInt();

  return (
    <Section background="linear-gradient(165deg, #0e121c 0%, #05070c 100%)" className={styles.root}>
      <div className={styles.grid}>
        <div className={styles.copy}>
          <TitleBlock
            title={t('You hear when they file, not at the next review.')}
            description={t(
              "Accounts land at the register on the company's timetable, not yours. Every company you monitor is re-read daily, so a new filing, a late filing or a change in the numbers reaches you the day it appears.",
            )}
            theme="dark"
            align="left"
          />
        </div>

        <div className={styles.widget} aria-label="Periodic review compared with perpetual monitoring">
          <div className={styles.cmpTop}>
            <span className={styles.cmpTitle}>
              {t('A borrower files accounts showing a 40% fall in net assets, in May.')}
            </span>
            <span className={styles.cmpTag}>{t('Illustrative')}</span>
          </div>

          <div className={styles.cmpBody}>
            <div className={styles.cmpLine}>
              <div className={styles.cmpHd}>
                <span className={styles.cmpL}>{t('Annual credit review')}</span>
                <span className={`${styles.cmpO} ${styles.anLate}`}>{t('You find out up to 3 months later')}</span>
              </div>

              <div className={styles.annoStrip}>
                <span className={`${styles.annoPin} ${styles.anFiling}`}>{t('Accounts filed')}</span>
              </div>

              <div className={styles.trk}>
                <span className={`${styles.gap} ${styles.anGap}`} />
                <i className={styles.tick} style={{ left: '8%' }} />
                <i className={styles.tick} style={{ left: '33%' }} />
                <i className={styles.tick} style={{ left: '58%' }} />
                <i className={styles.tick} style={{ left: '83%' }} />
                <i className={`${styles.pin} ${styles.pinRed} ${styles.anPinA}`} style={{ left: '36%' }} />
                <i className={`${styles.pin} ${styles.pinGrey} ${styles.anPinB}`} style={{ left: '58%' }} />
                <span className={`${styles.head} ${styles.anHead}`} />
              </div>

              <div className={styles.subStrip}>
                <span className={`${styles.gapl} ${styles.anGapl}`} style={{ left: '36%', width: '22%' }}>
                  {t('3 months exposed')}
                </span>
              </div>
            </div>

            <div className={`${styles.cmpLine} ${styles.cmpLineOn}`}>
              <div className={styles.cmpHd}>
                <span className={`${styles.cmpL} ${styles.cmpLDark}`}>{t('Monitored portfolio')}</span>
                <span className={`${styles.cmpO} ${styles.cmpOGreen} ${styles.anSame}`}>
                  {t('You find out the same day')}
                </span>
              </div>

              <div className={`${styles.trk} ${styles.trkLive}`}>
                <i className={`${styles.pin} ${styles.pinGreen} ${styles.anPinC}`} style={{ left: '36%' }} />
                <span className={`${styles.head} ${styles.anHead}`} />
              </div>

              <div className={styles.subStrip} />
            </div>

            <div className={styles.cmpAxis}>
              <span>Jan</span>
              <span>Apr</span>
              <span>Jul</span>
              <span>Oct</span>
              <span>Dec</span>
            </div>
          </div>
        </div>
      </div>
    </Section>
  );
};
